import { render, staticRenderFns } from "./cheguaList.vue?vue&type=template&id=63328ad2&"
import script from "./cheguaList.vue?vue&type=script&lang=js&"
export * from "./cheguaList.vue?vue&type=script&lang=js&"
import style0 from "./cheguaList.vue?vue&type=style&index=0&id=63328ad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports